import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import PropertyGrid from '../components/sections/PropertyGrid';

const Properties: React.FC = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header />
      <main>
        <section className="relative bg-slate-900 py-14 md:py-32">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-800" />
          <div className="container mx-auto px-4 relative z-10 pt-10 md:pt-16">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">精選物業</h1>
            <p className="text-slate-300 text-lg max-w-2xl">瀏覽金晉物業代理為您精選的優質工商舖物業。</p>
          </div>
        </section>
        <PropertyGrid />
      </main>
      <Footer />
    </div>
  );
};

export default Properties;
